



























import {
  computed,
  defineComponent,
  PropType,
  getCurrentInstance
} from "@vue/composition-api";
import { occFont } from "@/assets/styles/vars-for-script.scss";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "OccButton",
  components: {},
  props: {
    size: {
      type: String as PropType<"small" | "medium" | "large">,
      default: "medium",
      validator: (size: string) => {
        return ["", "small", "medium", "large"].includes(size);
      }
    },
    maxWidth: {
      type: String,
      default: undefined
    },
    minWidth: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: undefined
    },
    height: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: "primary",
      validator: (type: string) => {
        return ["", "primary", "outlined", "no-border", "alert"].includes(type);
      }
    },
    color: {
      type: String as PropType<"primary" | "black" | "gray20" | "alert">,
      default: "black",
      validator: (color: string) => {
        return ["", "primary", "black", "gray20", "alert"].includes(color);
      }
    },
    iconName: {
      type: String,
      default: ""
    },
    iconCustomSize: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: occFont
    },
    icon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: Object,
      default: null
    },
    innerStyle: {
      type: Object,
      default: null
    },
    innerClass: {
      type: String,
      default: ""
    },
    gaEventCategory: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots }) {
    const buttonStyle = computed(() => {
      const style = {
        "max-width": props.maxWidth,
        "min-width": props.minWidth,
        width: props.width,
        height: props.height
      };
      return props.customStyle ? { ...style, ...props.customStyle } : style;
    });

    const classes = computed(() => [
      props.size ? `occ-button__size--${props.size}` : "",
      props.type ? `occ-button__type--${props.type}` : "",
      props.color ? `occ-button__color--${props.color}` : "",
      props.disabled ? `occ-button--disabled` : "",
      props.bold ? `occ-button--bold` : "",
      props.loading ? `occ-button--loading` : ""
    ]);

    const iconClass = computed(() => [
      "occ-button__icon",
      !slots.default ? "occ-button__icon--only" : ""
    ]);

    const iconSize = computed(() => {
      switch (props.size) {
        case "small":
          return 12;
        case "medium":
          return 14;
        case "large":
          return 18;
      }
    });

    const loadingIconClasses = computed(() => [
      "occ-button-loading-icon",
      props.type ? `occ-button-loading-icon__type--${props.type}` : ""
    ]);

    const buttonContentStyle = computed(() =>
      props.loading ? { opacity: 0 } : undefined
    );

    const instance = getCurrentInstance();
    const handleClick = () => {
      if (instance) sendGaEvent(instance.proxy);
    };

    return {
      buttonStyle,
      classes,
      iconClass,
      iconSize,
      loadingIconClasses,
      buttonContentStyle,
      handleClick
    };
  }
});
